import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';
import { invalidateOrder } from './invalidateOrder';

interface ResetToPartbaySelectionsInput {
    orderId: string;
}

interface ResetToPartbaySelectionsResponse {
    partsReset: number;
}

const resetToPartbaySelections = async (data: ResetToPartbaySelectionsInput, sessionId: string | null) => {
    const { data: response } = await axios.put<ResetToPartbaySelectionsResponse>(
        `${API_URL}/order/part/reset-selections`,
        { orderId: data.orderId },
        { headers: { Authorization: sessionId } },
    );
    return response;
};

export const useResetToPartbaySelections = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: ResetToPartbaySelectionsInput) => resetToPartbaySelections(data, sessionContext?.sessionId ?? null),
        onSuccess: (_data, { orderId }) => {
            invalidateOrder(queryClient, orderId);
        },
    });
};
